'use client'

import * as React from 'react'
import { VariantProps, cva } from 'class-variance-authority'
import { clsx } from 'clsx'

export const $mktButton = cva(
  'flex h-11 px-7 transition rounded-lg focus:outline-none bg-dark-base border border-dark-border-solid items-center disabled:bg-dark-base select-none focus:border-dark-control-base'
)

export const $mktButtonText = cva(
  'text-sm space-x-1.5 disabled:text-dark-shade-hover select-none'
)

export type MktButtonProps = VariantProps<typeof $mktButton> &
  VariantProps<typeof $mktButtonText> &
  React.JSX.IntrinsicElements['button']

export const MktButton = React.forwardRef<HTMLButtonElement, MktButtonProps>(
  ({ className, ...buttonProps }, ref) => {
    return (
      <button
        {...buttonProps}
        ref={ref}
        className={clsx(
          $mktButton({ className }),
          $mktButtonText({ className })
        )}
      />
    )
  }
)
